import { Component, Input, forwardRef } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

@Component({
   selector: 'vc-textarea',
   templateUrl: './textarea.component.html',
   styleUrls: ['./textarea.component.scss'],
   standalone: false,
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         useExisting: forwardRef(() => VcTextareaComponent),
         multi: true,
      },
   ],
})
export class VcTextareaComponent implements ControlValueAccessor {
   @Input() label = ''
   @Input() placeholder = ''
   @Input() rows = 4
   @Input() maxlength = 500  
   @Input() disabled = false
   @Input() autoResize = true
   @Input() inputStyleClass = ''
   @Input() required = false

   value: string | null = null
   onChange = (_: any) => {}
   onTouched = () => {}

   writeValue(v: any) {
      this.value = v ?? null
   }
   registerOnChange(fn: any) {
      this.onChange = fn
   }
   registerOnTouched(fn: any) {
      this.onTouched = fn
   }
   setDisabledState(isDisabled: boolean) {
      this.disabled = isDisabled
   }
}
